import { useMemo } from 'react';
import Sheet from './Sheets';
import SheetContext from './SheetContext';
import { DEFAULT_BREAKPOINT_NAME } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StyleSheetProvider({
  children,
  breakpointMediaQueries
}) {
  const sheets = useMemo(() => {
    return breakpointMediaQueries.reduce((acc, [__breakpointName, mediaQuery]) => {
      const s = document.createElement('style');
      document.head.appendChild(s);
      acc[mediaQuery || DEFAULT_BREAKPOINT_NAME] = new Sheet(s.sheet);
      return acc;
    }, {});
  }, [breakpointMediaQueries]);
  return /*#__PURE__*/_jsx(SheetContext.Provider, {
    value: sheets,
    children: children
  });
}